import * as React from "react";
import { Provider, connect } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import { GlobalState } from "./store";
import * as headerActions from "./store/header/actions";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import IconButton from "@material-ui/core/IconButton";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}
const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);
function GlobalSnack(props: {
  title: string;
  open: boolean;
  type: string;
  close: () => any;
}) {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      open={props.open}
      autoHideDuration={3e3}
      onClose={props.close}
      message={<span id="message-id">{props.title}</span>}
    >
      <MySnackbarContentWrapper
        onClose={props.close}
        variant={props.type || "success"}
        message={props.title}
      />
    </Snackbar>
  );
}
const Snack = connect(
  (state: GlobalState) => ({
    open: state.header.showSnack,
    title: state.header.snackTitle,
    type: state.header.snackType
  }),
  dispatch => ({
    close: (): any => dispatch(headerActions.hideSnack())
  })
)(GlobalSnack);

export default Snack;



// WEBPACK FOOTER //
// ./src/snack.tsx